import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('../views/home')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login')
  },
  {
    path: '/reg',
    name: 'reg',
    component: () => import('../views/reg')
  },
  {
    path: '/regSuccess',
    name: 'regSuccess',
    component: () => import('../views/regSuccess')
  },
  {
    path: '/ability',
    name: 'ability',
    component: () => import('../views/ability/index'),
    redirect: '/ability/autotranslation',
    children: [
      {
        path: '/ability/autotranslation',
        name: 'autotranslation',
        component: () => import('../views/ability/autotranslation'),
      },
      {
        path: '/ability/aitranslation',
        name: 'aitranslation',
        component: () => import('../views/ability/aitranslation'),
      },
      {
        path: '/ability/voiceclon',
        name: 'voiceclon',
        component: () => import('../views/ability/voiceclon'),
      },
      {
        path: '/ability/crm',
        name: 'crm',
        component: () => import('../views/ability/crm'),
      },
      {
        path: '/ability/aireply',
        name: 'aireply',
        component: () => import('../views/ability/aireply'),
      },
      {
        path: '/ability/aiassistants',
        name: 'aiassistants',
        component: () => import('../views/ability/aiassistants'),
      }
    ]
  },
  {
    path: '/priceIntroduce',
    name: 'priceIntroduce',
    component: () => import('../views/priceIntroduce')
  },
  {
    path: '/help',
    name: 'help',
    component: () => import('../views/help')
  },
  {
    path: '/personal',
    name: 'personal',
    component: () => import('../views/personal')
  },
  {
    path: '/internalControl',
    name: 'internalControl',
    component: () => import('../views/internalControl')
  },
  {
    path: '/agreement',
    name: 'agreement',
    component: () => import('../views/agreement')
  },
  {
    path: '/resetPassword',
    name: 'resetPassword',
    component: () => import('../views/resetPassword')
  },
  {
    path: '/workshow/:id',
    name: 'workshow',
    component: () => import('../views/work/workshow')
  },
]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 解决报错
const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace

// push
Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
// replace
Router.prototype.replace = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}

export default router
